const productionPublicOrigin = "https://app.sbotlabs.com";

function isLocalHost(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

export function publicAppOrigin(location: Pick<Location, "hostname" | "origin"> = window.location): string {
  return isLocalHost(location.hostname) ? location.origin : productionPublicOrigin;
}

export function overlayPublicURL(overlayId: string, location?: Pick<Location, "hostname" | "origin">): string {
  return `${publicAppOrigin(location)}/overlay/${encodeURIComponent(overlayId)}`;
}

/** The URL operators place in the designated OBS/TriCaster browser source. */
export function overlayProgramURL(overlayId: string, location?: Pick<Location, "hostname" | "origin">): string {
  return `${overlayPublicURL(overlayId, location)}?mode=program`;
}

export function leagueOverlayPublicURL(outputId: string, location?: Pick<Location, "hostname" | "origin">): string {
  return `${publicAppOrigin(location)}/league-overlay/${encodeURIComponent(outputId)}`;
}

/** Stable per-league program URL that forwards to the currently selected overlay. */
export function leagueOverlayProgramURL(outputId: string, location?: Pick<Location, "hostname" | "origin">): string {
  return `${leagueOverlayPublicURL(outputId, location)}?mode=program`;
}

/** Public spectator GPS map — the unguessable share ID is the bearer token. */
export function gpsSharePublicURL(shareId: string, location?: Pick<Location, "hostname" | "origin">): string {
  return `${publicAppOrigin(location)}/share/gps/${encodeURIComponent(shareId)}`;
}
